import { useEffect, useRef } from 'react';

import { ErrorView } from '@gasbi/shared';

const LOGOUT_IN_MS = 3000;

// Shown to someone who signed in but has no representative in this cabinet (403 from the API).
// After a moment the session is ended through the cabinet API's logout endpoint, so the next
// visit starts from the Identity Server login page.
const Page = () => {
  const firedRef = useRef(false);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (firedRef.current) return;
      firedRef.current = true;
      window.location.assign('/api/logout?returnUrl=/');
    }, LOGOUT_IN_MS);

    return () => clearTimeout(timeoutId);
  }, []);

  return (
    <ErrorView
      title='Схоже, у вас немає доступу'
      description='Якщо це помилка – будь ласка, зверніться до адміністратора'
      hideHeader
      hideButton
    />
  );
};

export default Page;
